class EmployeeDropdownController {
  constructor($scope, $timeout, $element, $document) {
    "ngInject";
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.$document = $document;

    this.searchText = '';
    this.isOpen = false;
    this.filteredEmployees = [];
    this.mouseInDropdown = false;
    this._dropdownInBody = false;
    this._listElement = null;
  }

  $onChanges(changes) {
    if (changes.employees && this.employees) {
      if (this.selectedEmployee) {
        this.searchText = this.getDisplayName(this.selectedEmployee);
      }
      this.filterEmployees();
    }
  }

  $onInit() {
    if (this.selectedEmployee) {
      this.searchText = this.getDisplayName(this.selectedEmployee);
    }
    if (this.employees && this.employees.length) {
      this.filterEmployees();
    }

    this.$scope.$watch(() => this.employees, (newVal) => {
      if (newVal && newVal.length) {
        this.filterEmployees();
      }
    }, true);

    this.$scope.$watch(() => this.selectedEmployee, (newVal) => {
      if (newVal) {
        this.searchText = this.getDisplayName(newVal);
      } else {
        this.searchText = '';
      }
    });

    const self = this;
    this.$scope.$watch(() => this.isOpen, (isOpen) => {
      self.$timeout(() => self._updateDropdownPosition(isOpen), 0);
    });
    this.$scope.$on('$destroy', () => {
      if (self._dropdownInBody && self._listElement) {
        const el = self.$element[0];
        const holder = el && el.querySelector && el.querySelector('.employee-dropdown-list-holder');
        if (holder && self._listElement.parentNode === self.$document[0].body) {
          holder.appendChild(self._listElement);
        }
        self._dropdownInBody = false;
        self._listElement = null;
      }
    });
  }

  _updateDropdownPosition(isOpen) {
    const el = this.$element[0];
    const doc = this.$document[0];
    const holder = el && el.querySelector('.employee-dropdown-list-holder');
    const list = el && el.querySelector('.employee-dropdown-list');
    if (!holder || !list) return;

    if (isOpen && list.parentNode === holder) {
      const input = el.querySelector('.employee-dropdown-input');
      const rect = input ? input.getBoundingClientRect() : null;
      if (rect) {
        doc.body.appendChild(list);
        this._dropdownInBody = true;
        this._listElement = list;
        list.style.position = 'fixed';
        list.style.top = (rect.bottom + 2) + 'px';
        list.style.left = rect.left + 'px';
        list.style.width = rect.width + 'px';
        list.style.minWidth = rect.width + 'px';
      }
    } else if (!isOpen && this._dropdownInBody && this._listElement && this._listElement.parentNode === doc.body) {
      holder.appendChild(this._listElement);
      this._dropdownInBody = false;
      this._listElement.style.position = '';
      this._listElement.style.top = '';
      this._listElement.style.left = '';
      this._listElement.style.width = '';
      this._listElement.style.minWidth = '';
      this._listElement = null;
    }
  }

  getDisplayName(employee) {
    if (!employee) return '';
    if (employee.name) return employee.name;
    return [employee.firstName, employee.lastName].filter(Boolean).join(' ') || '';
  }

  sortByLastName(employees) {
    return employees.slice().sort((a, b) => {
      const lastA = (a.lastName || '').toLowerCase();
      const lastB = (b.lastName || '').toLowerCase();
      const cmp = lastA.localeCompare(lastB);
      if (cmp !== 0) return cmp;
      const firstA = (a.firstName || '').toLowerCase();
      const firstB = (b.firstName || '').toLowerCase();
      return firstA.localeCompare(firstB);
    });
  }

  filterEmployees() {
    const list = this.employees || [];
    let result;
    if (!this.searchText || this.searchText.trim() === '') {
      result = list.slice();
    } else {
      const searchLower = this.searchText.toLowerCase();
      result = list.filter(emp => {
        const name = this.getDisplayName(emp);
        return name && name.toLowerCase().includes(searchLower);
      });
    }
    this.filteredEmployees = this.sortByLastName(result);
  }

  onSearchChange() {
    this.filterEmployees();
  }

  onInputFocus() {
    this.isOpen = true;
    this.filterEmployees();
  }

  onInputBlur() {
    this.$timeout(() => {
      if (!this.mouseInDropdown) {
        this.isOpen = false;
      }
    }, 200);
  }

  onDropdownMouseEnter() {
    this.mouseInDropdown = true;
  }

  onDropdownMouseLeave() {
    this.mouseInDropdown = false;
    this.isOpen = false;
  }

  selectEmployee(employee) {
    this.selectedEmployee = employee;
    this.searchText = this.getDisplayName(employee);
    this.isOpen = false;

    if (this.onSelect) {
      this.onSelect({ employee: employee });
    }
  }

  clearSelection() {
    this.selectedEmployee = null;
    this.searchText = '';
    this.isOpen = false;

    if (this.onSelect) {
      this.onSelect({ employee: null });
    }
  }

  isSelected(employee) {
    if (!this.selectedEmployee) return false;
    const idA = this.selectedEmployee.paylocityEmployeeId != null
      ? this.selectedEmployee.paylocityEmployeeId
      : this.selectedEmployee.id;
    const idB = employee.paylocityEmployeeId != null
      ? employee.paylocityEmployeeId
      : employee.id;
    return idA === idB;
  }
}

export default EmployeeDropdownController;



// WEBPACK FOOTER //
// ./client/common/directives/employee-dropdown/employee-dropdown.controller.js